import { MutationTree } from "vuex";
import { RootState } from "./types";
// import Vue from "vue";

const TOGGLE_DRAWER = "TOGGLE_DRAWER";

const n = {
  TOGGLE_DRAWER
};

const mutations: MutationTree<RootState> = {
  [n.TOGGLE_DRAWER](state) {
    console.log(n.TOGGLE_DRAWER, !state.drawer);
    state.drawer = !state.drawer;
  }
};

export { n as mutationNames, mutations };
